module.exports = __webpack_public_path__ + "img/certification.ad19be4d.png";